import React from 'react';
import { Button } from '@mui/material';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import '../../../resources/global.css';

const AccountButton = ({ text, amount, onClick }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        minHeight: '56px',
        padding: '0 36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',

        color: 'var(--ft-dark)',
        backgroundColor: 'var(--ft-white)',
        border: '1px solid var(--ft-mid-grey)',
        textTransform: 'none',
        borderRadius: 0,

        '&:hover': {
          backgroundColor: 'var(--ft-white)',
          borderColor: 'var(--ft-mid-grey)'
        }
      }}>
      <span
        style={{
          fontFamily: 'var(--ft-h5-font-family)',
          fontSize: 'var(--ft-h5-font-size)',
          fontWeight: 'var(--ft-h5-font-weight)',
          lineHeight: 'var(--ft-h5-line-height)',
          color: 'var(--ft-dark)'
        }}>
        {text}
      </span>

      <span
        style={{
          marginLeft: 'auto',
          fontFamily: 'var(--ft-body-font-family)',
          fontSize: 'var(--ft-body-font-size)',
          fontWeight: 'var(--ft-body-font-weight)',
          lineHeight: 'var(--ft-body-line-height)',
          color: 'var(--ft-dark)'
        }}>
        {amount}
      </span>

      <ArrowForwardOutlinedIcon
        sx={{
          marginLeft: '12px',
          fontSize: '14px',
          color: 'var(--ft-dark)'
        }}
      />
    </Button>
  );
};

export default AccountButton;
